import { createAsyncThunk } from '@reduxjs/toolkit';
import * as marketPlaceApi from '../../api/marketPlace';

export const getMarketPlace = createAsyncThunk('getMarketPlace', async (data) => {
    const res = await marketPlaceApi.getMarketPlace({ data: data });
    return res.data;
});
export const getMarketPlaceList = createAsyncThunk('getMarketPlaceList', async (data) => {
    const res = await marketPlaceApi.getMarketPlaceList({ data: data });
    return res.data;
});  

export const deleteMarketPlace = createAsyncThunk('deleteMarketPlace', async (data) => {
    const res = await marketPlaceApi.deleteMarketPlace({ data: data });
    return res.data;
});
export const getMarketPlaceTypes = createAsyncThunk('getMarketPlaceTypes', async (data) => {
    const res = await marketPlaceApi.getMarketPlaceTypes({ data: data });
    return res.data;
});

